<template>
    <div class="py-2">
      
      <label for="{{forLabel}}" class="block text-sm font-medium text-gray-700"><span v-if="required" class="text-rose-600">*</span> {{label}}</label>
      <div class="mt-1">
        <div class="flex flex-col w-full" >
          <div v-for="(phone,index) in listPhones.phones" :key="index" class="flex items-center gap-2 pb-2">
            <div>
              <select v-model="phone.type" class="defaultInput" :class="name ? fieldsError[field_id] ? 'bg-rose-50' : '': ''">
                <option v-for="(type,index) in types" :key="index" :value="type">{{ type }}</option>
              </select>
            </div>
            <div>
              <input type="text" :name="'phone_' + index" v-model="phone.number" class="defaultInput" placeholder="(**) *****-****" :class="name ? fieldsError[field_id] ? 'bg-rose-50' : '': ''">
            </div>

            <div v-if="index != 0">
              <XMarkIcon @click="removePhone(index)" class="cursor-pointer h-6 w-6 rounded-full bg-gray-100 p-1 hover:bg-rose-600 hover:text-white" />
            </div>
          </div>
          <div @click="addPhone" class="flex justify-center items-center rounded-md w-[140px] bg-gray-100 hover:bg-gray-200 text-xs p-1 cursor-pointer">+ Adicionar telefone</div>
        </div>
      
      </div>
    </div>
    
  </template>
  
  <script>

import { XMarkIcon } from '@heroicons/vue/24/solid';

  
  export default {
      name: 'Phones',
      props: {
        value: {
          type: Object,
          required: false,
        },
        name: {
            type: String,
            required: false,
        },
        field_id: {
            type: [String, Number],
            required: false,
        },
        label: {
          type: String,
          required: false,
        },       
        required: {
          type: Boolean,
          required: false,
          default: false,
        }, 
        
        types: {
          type: Array,
          required: true,
        },

        fieldsError: {
          type: Object,
          required: false,
        },            

      },
  
      data() {
          return {
            errorClass: '',
            listPhones: {
              id: this.field_id,
              label: this.label,
              name: this.name,
              phones: [
                {
                  type: 'phone',
                  number: '',
                },
              ],
            }
          }
      },
  
      methods: {

        addPhone() {
          this.listPhones.phones.push({
            type: 'phone',
            number: '',
          });
        },

        removePhone(index) {
          this.listPhones.phones.splice(index, 1);
        },
        
 
      },
      
      watch: {
        listPhones: {
          handler: function (val, oldVal) {
            this.$emit('update:modelValue', this.listPhones);
          },
          deep: true,
        },
               
      },
     
      created() {
        if (this.value) {
          this.listPhones.phones = this.value;
        }
        
      },

        components: {
          XMarkIcon,
        },

  }
  </script>